// extracted by mini-css-extract-plugin
export var closed = "_ar-1";
export var resizer = "_ar-0";